<template>
  <b-overlay :show="loading">
    <div class="employment-details-container p-4">
      <div class="card shadow-sm border-0">
        <div
          class="card-header bg-light-blue py-3 d-flex justify-content-between align-items-center border-bottom"
        >
          <div class="text-center flex-grow-1">
            <p
              class="mb-1 font-weight-bold"
              style="color: #333; font-size: 0.85rem"
            >
              Bangladesh Gazette - বাংলাদেশ গেজেট
            </p>
            <h5 class="mb-1 font-weight-bold text-primary">Form No: 07</h5>
            <p class="mb-1 text-muted small">
              Under Section 7, Rules (1) and (2)
            </p>
            <p class="mb-1 text-muted small">Second Part (B)</p>
            <h6 class="mb-0 font-weight-bold">
              Employer and Employment details
            </h6>
            <p class="mb-0 small bn-text">মালিকের ও চাকরির তথ্য</p>
          </div>
          <b-button
            variant="primary"
            size="sm"
            class="add-entry-btn shadow-sm"
            @click="openAddModal"
          >
            <i class="fa fa-plus-circle mr-1"></i> Add Record
          </b-button>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-bordered mb-0 custom-table">
              <thead class="text-center bg-light-cyan">
                <tr>
                  <th
                    @click="sortBy('factory_name_address')"
                    :class="
                      sortKey == 'factory_name_address'
                        ? sortOrders['factory_name_address'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Factory/Organization Name & Address<br />
                    <small class="bn-text"
                      >কারখানার/প্রতিষ্ঠানের নাম ও ঠিকানা</small
                    >
                  </th>
                  <th
                    @click="sortBy('owner_authority_name')"
                    :class="
                      sortKey == 'owner_authority_name'
                        ? sortOrders['owner_authority_name'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Owner/ Management Authority Name<br />
                    <small class="bn-text"
                      >মালিক/ব্যবস্থাপনা কর্তৃপক্ষের নাম</small
                    >
                  </th>
                  <th
                    @click="sortBy('joining_date')"
                    :class="
                      sortKey == 'joining_date'
                        ? sortOrders['joining_date'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Joining Date<br />
                    <small class="bn-text">যোগদানের তারিখ</small>
                  </th>
                  <th
                    @click="sortBy('resignation_termination_date')"
                    :class="
                      sortKey == 'resignation_termination_date'
                        ? sortOrders['resignation_termination_date'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Resignation/ Termination Date<br />
                    <small class="bn-text">চাকরির ত্যাগ/অবসানের তারিখ</small>
                  </th>
                  <th
                    @click="sortBy('reason_of_termination')"
                    :class="
                      sortKey == 'reason_of_termination'
                        ? sortOrders['reason_of_termination'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Type/Reason of Resignation or Termination<br />
                    <small class="bn-text">ত্যাগ/অবসানের ধরণ/কারণ</small>
                  </th>
                  <th>
                    Signature of Owner/ Authorized Person<br />
                    <small class="bn-text"
                      >মালিক/প্রাধিকারপ্রান্ত ব্যক্তির স্বাক্ষর</small
                    >
                  </th>
                  <th>
                    Worker’s Signature<br />
                    <small class="bn-text">শ্রমিকের স্বাক্ষর</small>
                  </th>
                  <th>
                    Thumb Impression<br />
                    <small class="bn-text">টিপসই</small>
                  </th>
                  <th style="width: 80px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paginatedData.length == 0 && !loading">
                  <td colspan="9" class="text-center py-5 text-muted"> <!-- Mustafijur: 20-05-2026: colspan="9" -->
                    No records found.
                    <br><span class="bn-text">কোন তথ্য পাওয়া যায়নি</span>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in paginatedData"
                  :key="item.id"
                  class="text-center"
                >
                  <td>
                    <div class="text-left">
                      <div class="font-weight-bold">
                        {{ getJsonValue(item.factory_name_address, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.factory_name_address, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-left">
                      <div class="font-weight-bold">
                        {{ getJsonValue(item.owner_authority_name, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.owner_authority_name, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    {{ formatDate(item.joining_date) }}
                    <br v-if="item.id == activeRecordId" />
                    <span
                      v-if="item.id == activeRecordId"
                      style="color: #28a745; font-size: 11px"
                      >&#10004; (Active)</span
                    >
                  </td>
                  <td>{{ formatDate(item.resignation_termination_date) }}</td>
                  <td>
                    <div class="text-left">
                      <div>
                        {{ getJsonValue(item.reason_of_termination, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.reason_of_termination, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <b-link v-if="item.owner_signature" @click="downloadWithName(item.owner_signature, 'Owner_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <span v-else class="text-muted small">No signature available.</span>
                  </td>
                  <td>
                    <b-link v-if="item.worker_signature" @click="downloadWithName(item.worker_signature, 'Worker_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <span v-else></span>
                  </td>
                  <td>
                    <b-link v-if="item.worker_thumb_impression" @click="downloadWithName(item.worker_thumb_impression, 'Thumb_Impression')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <span v-else></span>
                  </td>
                    <td class="position-relative text-center">
                        <template v-if="item.id !== activeRecordId">
                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-ellipsis-v text-muted"></i>
                            </a>
                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                <b-button-toolbar class="">
                                    <b-button-group class="mr-0">
                                        <b-button class="border-0 rounded mb-1" variant="secondary" title="Edit" @click="editItem(item)">
                                            <i class="fa fa-edit mr-2"></i>Edit
                                        </b-button>
                                        <b-button class="border-0 rounded mb-1" variant="secondary" title="Delete" @click="confirmDelete(item.id)">
                                            <i class="fa fa-trash mr-2"></i>Delete
                                        </b-button>
                                    </b-button-group>
                                </b-button-toolbar>
                            </div>
                        </template>
                        <template v-else>
                            <span class="text-muted small">N/A</span>
                        </template>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="card-footer bg-white border-top py-3"
          v-if="pagination.pages > 1"
        >
          <b-pagination-nav
            v-model="pagination.currentPage"
            :number-of-pages="pagination.pages"
            base-url="#"
            prev-text="Previous"
            next-text="Next"
            first-number
            last-number
            align="center"
            class="mb-0"
          ></b-pagination-nav>
        </div>
      </div>
    </div>

    <!-- Add/Edit Modal -->
    <b-modal
      v-model="showModal"
      :title="isEdit ? 'Edit Employment Detail' : 'Add New Employment Detail'"
      @hidden="resetForm"
      size="lg"
      hide-footer
    >
      <form @submit.prevent="saveDetail" novalidate>
        <div class="row">
          <div class="col-md-6 border-right">
            <h6 class="font-weight-bold border-bottom pb-2 mb-3">
              English Details
            </h6>
            <b-form-group>
              <template #label>
                Factory/Organization Name &amp; Address: <span class="text-danger">*</span>
              </template>
              <b-form-textarea
                v-model="form.factory_name_address.en"
                rows="3"
                :disabled="isAutofetched"
                :state="submitAttempted && !form.factory_name_address.en ? false : (form.factory_name_address.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.factory_name_address.en) ? false : null)"
              ></b-form-textarea>
              <b-form-invalid-feedback :state="submitAttempted && !form.factory_name_address.en ? false : null">Factory/Organization Name &amp; Address (English) is required</b-form-invalid-feedback>
              <b-form-invalid-feedback :state="form.factory_name_address.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.factory_name_address.en) ? false : null">Factory Name must contain letters or numbers</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group>
              <template #label>
                Owner/Management Name: <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.owner_authority_name.en"
                :disabled="isAutofetched"
                :state="submitAttempted && !form.owner_authority_name.en ? false : (form.owner_authority_name.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.owner_authority_name.en) ? false : null)"
              ></b-form-input>
              <b-form-invalid-feedback :state="submitAttempted && !form.owner_authority_name.en ? false : null">Owner/Management Name (English) is required</b-form-invalid-feedback>
              <b-form-invalid-feedback :state="form.owner_authority_name.en && !/[a-zA-Z0-9ঀ-৿]/.test(form.owner_authority_name.en) ? false : null">Owner/Management Name must contain letters or numbers</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Reason for Termination:">
              <b-form-textarea
                v-model="form.reason_of_termination.en"
                :disabled="isAutofetched"
              ></b-form-textarea>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <h6 class="font-weight-bold border-bottom pb-2 mb-3 bn-text">
              বাংলা তথ্য
            </h6>
            <b-form-group label="কারখানার/প্রতিষ্ঠানের নাম ও ঠিকানা:">
              <b-form-textarea
                v-model="form.factory_name_address.bn"
                rows="3"
                class="bn-text"
                :disabled="isAutofetched"
                :state="(form.factory_name_address.bn && !/[\u0980-\u09FF]/.test(form.factory_name_address.bn) ? false : null)"
              ></b-form-textarea>
              <b-form-invalid-feedback :state="form.factory_name_address.bn && !/[\u0980-\u09FF]/.test(form.factory_name_address.bn) ? false : null">Factory Name (Bangla) must contain Bangla letters</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="মালিক/ব্যবস্থাপনা কর্তৃপক্ষের নাম:">
              <b-form-input
                v-model="form.owner_authority_name.bn"
                class="bn-text"
                :disabled="isAutofetched"
                :state="(form.owner_authority_name.bn && !/[\u0980-\u09FF]/.test(form.owner_authority_name.bn) ? false : null)"
              ></b-form-input>
              <b-form-invalid-feedback :state="form.owner_authority_name.bn && !/[\u0980-\u09FF]/.test(form.owner_authority_name.bn) ? false : null">Owner/Management Name (Bangla) must contain Bangla letters</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="ত্যাগ/অবসানের ধরণ/কারণ:">
              <b-form-textarea
                v-model="form.reason_of_termination.bn"
                class="bn-text"
                :disabled="isAutofetched"
                :state="form.reason_of_termination.bn && !/[\u0980-\u09FF]/.test(form.reason_of_termination.bn) ? false : null"
              ></b-form-textarea>
              <b-form-invalid-feedback :state="form.reason_of_termination.bn && !/[\u0980-\u09FF]/.test(form.reason_of_termination.bn) ? false : null">Termination Reason (Bangla) must contain Bangla letters</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <template #label>
                Joining Date (যোগদানের তারিখ)
                <span class="text-danger">*</span>
              </template>
              <b-input-group>
                <b-form-input
                  v-model="form.joining_date"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  :disabled="isAutofetched"
                  :state="joiningDateState"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="form.joining_date"
                    button-only
                    right
                    locale="en-US"
                    :disabled="isAutofetched"
                    :max="maxJoiningDate"
                    :min="minJoiningDate"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback :state="joiningDateState">{{ joiningDateFeedback }}</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <template #label>
                Termination Date (চাকরির ত্যাগ/অবসানের তারিখ)
                <span v-if="!(isEdit && editId == activeRecordId)" class="text-danger">*</span>
              </template>
              <b-input-group>
                <b-form-input
                  v-model="form.resignation_termination_date"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  :disabled="isAutofetched"
                  :state="terminationDateState"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="form.resignation_termination_date"
                    button-only
                    right
                    locale="en-US"
                    :disabled="isAutofetched"
                    :max="maxTerminationDate"
                    :min="minTerminationDate"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback :state="terminationDateState">{{ terminationDateFeedback }}</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>

        <div class="row mt-3 border-top pt-3">
          <div class="col-md-4 text-center border-left">
            <label class="font-weight-bold small d-block"
              >Worker's Signature
              <span class="bn-text">(শ্রমিকের স্বাক্ষর)</span>:</label
            >
            <div v-if="workerSigPreview" class="mt-2 text-center">
              <b-link @click="downloadWithName(worker_signature_raw, 'Worker_Signature')">
                <b-icon icon="download" scale="1.2"></b-icon> Download
              </b-link>
            </div>
            <div v-else class="text-muted small">No signature available</div>
          </div>
          <div class="col-md-4 text-center border-left">
            <label class="font-weight-bold small d-block"
              >Thumb Impression <span class="bn-text">(টিপসই)</span>:</label
            >
            <div v-if="thumbImpPreview" class="mt-2 text-center">
              <b-link @click="downloadWithName(thumb_impression_raw, 'Thumb_Impression')">
                <b-icon icon="download" scale="1.2"></b-icon> Download
              </b-link>
            </div>
            <div v-else class="text-muted small">No impression available</div>
          </div>
        </div>

        <div class="text-right mt-4 pt-3 border-top">
          <b-button variant="secondary" @click="showModal = false" class="mr-2">Cancel</b-button>
          <b-button type="submit" variant="primary" :disabled="saving || dateError || (!isEdit && form.joining_date && oldestJoiningDate && form.joining_date >= oldestJoiningDate)">
            {{ isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </form>
    </b-modal>
  </b-overlay>
</template>
<script>
export default {
  props: {
    isEmbedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var sortOrders = {};
    ["factory_name_address", "owner_authority_name", "joining_date", "resignation_termination_date", "reason_of_termination"].forEach((key) => {
      sortOrders[key] = 1;
    });
    return {
      apiPrefix: "/front/service-book",
      loading: false,
      saving: false,
      tableData: [],
      activeRecordId: null,
      sortKey: "joining_date",
      sortOrders: sortOrders,
      pagination: { currentPage: 1, perPage: 10, total: 0, pages: 0 },
      showModal: false,
      isEdit: false,
      editId: null,
      submitAttempted: false,
      form: {
        factory_name_address: { en: "", bn: "" },
        owner_authority_name: { en: "", bn: "" },
        reason_of_termination: { en: "", bn: "" },
        joining_date: "",
        resignation_termination_date: "",
      },
      ownerSigPreview: null,
      workerSigPreview: null,
      thumbImpPreview: null,
      owner_signature_raw: null,
      worker_signature_raw: null,
      thumb_impression_raw: null,
      signatories: [],
      selected_signatory_id: null,
      isAutofetched: false,
    };
  },
  computed: {
    filteredData() {
      var data = this.tableData;
      var sortKey = this.sortKey;
      var order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        data = data.slice().sort((a, b) => {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return data;
    },
    paginatedData() {
      const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
      return this.filteredData.slice(start, start + this.pagination.perPage);
    },
    signatoryOptions() {
      var options = [{ value: null, text: "Select Signatory" }];
      this.signatories.forEach(function (s) {
        options.push({
          value: s.id,
          text: s.name + " — " + (s.designation || ""),
        });
      });
      return options;
    },
    dateError() {
      if (this.form.joining_date && this.form.resignation_termination_date && this.form.joining_date >= this.form.resignation_termination_date) {
        return true;
      }
      return false;
    },
    oldestJoiningDate() {
      if (this.isEdit && this.editId == this.activeRecordId) {
        return null;
      }
      let oldest = null;
      this.tableData.forEach((item) => {
        if (this.isEdit && item.id === this.editId) {
          return;
        }
        if (item.joining_date) {
          const dateStr = (item.joining_date + "").substring(0, 10);
          if (!oldest || dateStr < oldest) {
            oldest = dateStr;
          }
        }
      });
      return oldest;
    },
    dateLimits() {
      let active = (this.items || this.tableData || []).find(item => !item.resignation_termination_date);
      let activeJoining = active ? String(active.joining_date).substring(0, 10) : null;
      
      let previousJobs = (this.items || this.tableData || [])
        .filter(item => item.resignation_termination_date && (!this.isEdit || item.id !== this.editId))
        .map(item => ({
          joining_date: String(item.joining_date).substring(0, 10),
          resignation_termination_date: String(item.resignation_termination_date).substring(0, 10)
        }));
      previousJobs.sort((a, b) => a.joining_date.localeCompare(b.joining_date));
      
      if (!this.isEdit) {
        let upperLimit = previousJobs.length > 0 ? previousJobs[0].joining_date : activeJoining;
        let limitStr = upperLimit ? this.addDays(upperLimit, -1) : null;
        return {
          joiningMax: limitStr,
          joiningMin: '1970-01-01',
          terminationMax: limitStr,
          terminationMin: '1970-01-01'
        };
      } else {
        if (this.editId === this.activeRecordId) {
          let newestPrev = previousJobs.length > 0 ? previousJobs[previousJobs.length - 1] : null;
          let minStr = newestPrev ? this.addDays(newestPrev.resignation_termination_date, 1) : '1970-01-01';
          return {
            joiningMax: null,
            joiningMin: minStr,
            terminationMax: null,
            terminationMin: null
          };
        } else {
          let origRecord = (this.items || this.tableData || []).find(item => item.id === this.editId);
          if (!origRecord) return { joiningMax: null, joiningMin: '1970-01-01', terminationMax: null, terminationMin: '1970-01-01' };
          
          let allPrev = (this.items || this.tableData || [])
            .filter(item => item.resignation_termination_date)
            .map(item => ({
              id: item.id,
              joining_date: String(item.joining_date).substring(0, 10),
              resignation_termination_date: String(item.resignation_termination_date).substring(0, 10)
            }));
          allPrev.sort((a, b) => a.joining_date.localeCompare(b.joining_date));
          
          let idx = allPrev.findIndex(item => item.id === this.editId);
          if (idx === -1) return { joiningMax: null, joiningMin: '1970-01-01', terminationMax: null, terminationMin: '1970-01-01' };
          
          let prevJob = idx > 0 ? allPrev[idx - 1] : null;
          let nextJob = idx < allPrev.length - 1 ? allPrev[idx + 1] : null;
          
          let jMin = prevJob ? this.addDays(prevJob.resignation_termination_date, 1) : '1970-01-01';
          
          let tMax = activeJoining;
          if (nextJob) {
            tMax = this.addDays(nextJob.joining_date, -1);
          } else if (activeJoining) {
            tMax = this.addDays(activeJoining, -1);
          }
          
          return {
            joiningMax: this.form.resignation_termination_date ? this.form.resignation_termination_date : tMax,
            joiningMin: jMin,
            terminationMax: tMax,
            terminationMin: this.form.joining_date ? this.form.joining_date : jMin
          };
        }
      }
    },
    maxJoiningDate() {
      return this.dateLimits.joiningMax;
    },
    minJoiningDate() {
      return this.dateLimits.joiningMin;
    },
    maxTerminationDate() {
      return this.dateLimits.terminationMax;
    },
    minTerminationDate() {
      return this.dateLimits.terminationMin;
    },
    joiningDateState() {
      if (this.submitAttempted && !this.form.joining_date) return false;
      if (this.form.joining_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.joining_date)) return false;
        if (this.form.joining_date < "1970-01-01") return false;
        if (this.minJoiningDate && this.form.joining_date < this.minJoiningDate) return false;
        if (this.maxJoiningDate && this.form.joining_date > this.maxJoiningDate) return false;
      }
      return null;
    },
    terminationDateState() {
      const isActive = this.isEdit && this.editId === this.activeRecordId;
      if (this.submitAttempted && !isActive && !this.form.resignation_termination_date) return false;
      if (this.form.resignation_termination_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.resignation_termination_date)) return false;
        if (this.form.joining_date && this.form.resignation_termination_date <= this.form.joining_date) return false;
        if (this.minTerminationDate && this.form.resignation_termination_date < this.minTerminationDate) return false;
        if (this.maxTerminationDate && this.form.resignation_termination_date > this.maxTerminationDate) return false;
      }
      return null;
    },
    joiningDateFeedback() {
      if (this.submitAttempted && !this.form.joining_date) return "Joining Date is required";
      if (this.form.joining_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.joining_date)) return "Joining Date must be in YYYY-MM-DD format";
        if (this.form.joining_date < "1970-01-01") return "Joining Date cannot be earlier than 1970-01-01";
        if (this.minJoiningDate && this.form.joining_date < this.minJoiningDate) {
          return "Joining Date must be after the previous job's resignation date (" + this.formatDate(this.minJoiningDate) + ")";
        }
        if (this.maxJoiningDate && this.form.joining_date > this.maxJoiningDate) {
          if (!this.isEdit) {
            return "Joining Date must be earlier than the oldest joining date (" + this.formatDate(this.maxJoiningDate) + ")";
          } else {
            return "Joining Date must be earlier than the next job's joining date (" + this.formatDate(this.maxJoiningDate) + ")";
          }
        }
      }
      return "";
    },
    terminationDateFeedback() {
      const isActive = this.isEdit && this.editId === this.activeRecordId;
      if (this.submitAttempted && !isActive && !this.form.resignation_termination_date) return "Termination Date is required";
      if (this.form.resignation_termination_date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.resignation_termination_date)) return "Termination Date must be in YYYY-MM-DD format";
        if (this.form.joining_date && this.form.resignation_termination_date <= this.form.joining_date) {
          return "Termination Date must be after Joining Date";
        }
        if (this.minTerminationDate && this.form.resignation_termination_date < this.minTerminationDate) {
          return "Termination Date must be after Joining Date (" + this.formatDate(this.minTerminationDate) + ")";
        }
        if (this.maxTerminationDate && this.form.resignation_termination_date > this.maxTerminationDate) {
          return "Termination Date must be before the next job's joining date (" + this.formatDate(this.maxTerminationDate) + ")";
        }
      }
      return "";
    },
  },
  watch: {
    filteredData(newData) {
      this.pagination.total = newData.length;
      this.pagination.pages = Math.ceil(newData.length / this.pagination.perPage);
    },
  },
  created() {
    this.fetchData();
    this.fetchSignatories();
  },
  methods: {
    addDays(dateStr, days) {
      if (!dateStr) return null;
      let date = new Date(dateStr);
      date.setDate(date.getDate() + days);
      let yyyy = date.getFullYear();
      let mm = String(date.getMonth() + 1).padStart(2, '0');
      let dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    fetchData() {
      this.loading = true;
      axios
        .post(this.$api_url + this.apiPrefix + "/employment-details/fetch", {})
        .then((response) => {
          this.tableData = response.data.records || [];
          this.activeRecordId = response.data.active_record_id;
          this.tableData.forEach((item) => {
            if (item.owner_signature) this.fetchAsBlob(item.owner_signature).then(b => { this.$set(item, '_ownerBlob', b); });
            if (item.worker_signature) this.fetchAsBlob(item.worker_signature).then(b => { this.$set(item, '_workerBlob', b); });
            if (item.worker_thumb_impression) this.fetchAsBlob(item.worker_thumb_impression).then(b => { this.$set(item, '_thumbBlob', b); });
          });
        })
        .finally(() => { this.loading = false; });
    },
    fetchAsBlob(url) {
      if (!url) return Promise.resolve(null);
      if (url.startsWith("data:")) return Promise.resolve(url);
      const imageUrl = this.getImageUrl(url);
      return fetch(imageUrl, { credentials: 'same-origin' })
        .then(r => r.blob())
        .then(blob => URL.createObjectURL(blob))
        .catch(() => imageUrl);
    },
    getImageUrl(path) {
      if (!path) return null;
      if (path.startsWith("http") || path.startsWith("data:")) return path;
      return "/" + path;
    },
    getJsonValue(v, lang) {
      if (!v) return "";
      try {
        const parsed = typeof v === "object" ? v : JSON.parse(v);
        return parsed[lang] || "";
      } catch (e) { return v; }
    },
    downloadWithName(path, name) {
      if (!path) return;
      if (path.startsWith('data:image/')) {
        try {
          const parts = path.split(';base64,');
          const contentType = parts[0].split(':')[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) uInt8Array[i] = raw.charCodeAt(i);
          const blob = new Blob([uInt8Array], { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = name + '.' + contentType.split('/')[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
          return;
        } catch (e) {
          console.error("Base64 download failed, falling back to direct URL", e);
        }
      }
      const url = this.getImageUrl(path);
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    openAddModal() {
      this.resetForm();
      this.showModal = true;
      this.fetchCurrentSignatures();
    },
    fetchCurrentSignatures() {
      axios.post(this.$api_url + this.apiPrefix + "/get-worker-identification", {})
        .then((response) => {
          const doc = response.data;
          if (doc.owner_signature) {
             this.owner_signature_raw = doc.owner_signature;
             this.fetchAsBlob(doc.owner_signature).then((b) => { this.ownerSigPreview = b; });
          }
          if (doc.signature) {
             this.worker_signature_raw = doc.signature;
             this.fetchAsBlob(doc.signature).then((b) => { this.workerSigPreview = b; });
          }
          if (doc.worker_thumb_impression) {
             this.thumb_impression_raw = doc.worker_thumb_impression;
             this.fetchAsBlob(doc.worker_thumb_impression).then((b) => { this.thumbImpPreview = b; });
          }
        });
    },
    editItem(item) {
      this.isEdit = true;
      this.editId = item.id;
      // Updated by Jarir 2026-05-04 — active record or autofetched record is readonly
      this.isAutofetched = item.is_autofetched == 1 || item.id == this.activeRecordId;

      const parseJsonField = (field) => {
        if (!field) return { en: "", bn: "" };
        if (typeof field === "object") return field;
        try { return JSON.parse(field); } catch (e) { return { en: field, bn: "" }; }
      };

      this.form = {
        factory_name_address: parseJsonField(item.factory_name_address),
        owner_authority_name: parseJsonField(item.owner_authority_name),
        reason_of_termination: parseJsonField(item.reason_of_termination),
        joining_date: (item.joining_date + "").substring(0, 10),
        resignation_termination_date: item.resignation_termination_date ? (item.resignation_termination_date + "").substring(0, 10) : "",
      };
      this.selected_signatory_id = item.signatory_id || null;

      if (item.owner_signature) {
        this.owner_signature_raw = item.owner_signature;
        this.fetchAsBlob(item.owner_signature).then((b) => { this.ownerSigPreview = b; });
      } else {
        this.ownerSigPreview = null;
        this.owner_signature_raw = null;
      }

      if (item.worker_signature) {
        this.worker_signature_raw = item.worker_signature;
        this.fetchAsBlob(item.worker_signature).then((b) => { this.workerSigPreview = b; });
      } else {
        this.workerSigPreview = null;
        this.worker_signature_raw = null;
      }

      if (item.worker_thumb_impression) {
        this.thumb_impression_raw = item.worker_thumb_impression;
        this.fetchAsBlob(item.worker_thumb_impression).then((b) => { this.thumbImpPreview = b; });
      } else {
        this.thumbImpPreview = null;
        this.thumb_impression_raw = null;
      }

      this.showModal = true;
    },
    confirmDelete(id) {
      this.$bvModal.msgBoxConfirm("Are you sure you want to delete this record?", {
        title: "Confirm Delete", okVariant: "danger", okTitle: "Delete", cancelTitle: "Cancel",
      }).then((confirmed) => {
        if (confirmed) {
          axios.delete(this.$api_url + this.apiPrefix + "/employment-details/" + id)
            .then(() => {
              this.$bvToast.toast("Deleted successfully", { title: "Success", variant: "success", solid: true, autoHideDelay: 3000 });
              this.fetchData();
            })
            .catch((err) => {
              // Updated by Jarir 2026-05-04 — show server-side error message if delete fails (e.g. active record)
              const msg = err.response && err.response.data && err.response.data.error ? err.response.data.error : "Error deleting record";
              this.$bvToast.toast(msg, { title: "Error", variant: "danger", solid: true, autoHideDelay: 5000 });
            });
        }
      });
    },
    saveDetail() {
      const errors = [];
      // Updated by Tareq Sifat 2026-08-02 — Bangla name/address fields are optional (labels carry no *, backend does not require them)
      if (!this.form.factory_name_address.en) errors.push("Factory Name (English) is required");
      if (!this.form.owner_authority_name.en) errors.push("Owner Name (English) is required");
      if (!this.form.joining_date) {
        errors.push("Joining Date is required");
      } else {
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateRegex.test(this.form.joining_date)) {
          errors.push("Joining Date must be in YYYY-MM-DD format");
        }
      }

      const isActive = this.isEdit && this.editId === this.activeRecordId;
      if (!isActive) {
        if (!this.form.resignation_termination_date) {
          errors.push("Termination Date is required");
        } else {
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (!dateRegex.test(this.form.resignation_termination_date)) {
            errors.push("Termination Date must be in YYYY-MM-DD format");
          }
        }
      }

      this.submitAttempted = true;
      if (errors.length > 0) {
        this.$bvToast.toast("Please fill all required fields: " + errors.join(", "), {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      if (!isActive && this.form.joining_date >= this.form.resignation_termination_date) {
        this.$bvToast.toast("Joining Date must be earlier than Termination Date.", {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      if (this.form.joining_date < "1970-01-01") {
        this.$bvToast.toast("Joining Date cannot be earlier than 1970-01-01.", {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      let activeJoining = null;
      let previousJobs = [];

      this.tableData.forEach((item) => {
        let id = item.id;
        let joining = item.joining_date;
        let resignation = item.resignation_termination_date;

        if (this.isEdit && id === this.editId) {
          joining = this.form.joining_date;
          resignation = this.form.resignation_termination_date;
        }

        let joiningStr = joining ? String(joining).substring(0, 10) : null;
        let resignationStr = resignation ? String(resignation).substring(0, 10) : null;

        if (!resignationStr) {
          activeJoining = joiningStr;
        } else {
          previousJobs.push({
            id: id,
            joining_date: joiningStr,
            resignation_termination_date: resignationStr
          });
        }
      });

      if (!this.isEdit) {
        let joiningStr = String(this.form.joining_date).substring(0, 10);
        let resignationStr = String(this.form.resignation_termination_date).substring(0, 10);
        previousJobs.push({
          id: null,
          joining_date: joiningStr,
          resignation_termination_date: resignationStr
        });
      }

      previousJobs.sort((a, b) => a.joining_date.localeCompare(b.joining_date));

      if (!this.isEdit) {
        const newRecordIndex = previousJobs.findIndex((job) => job.id === null);
        if (newRecordIndex !== 0) {
          this.$bvToast.toast("Any new employment record must be older than the oldest existing record.", {
            title: "Sequential Date Conflict",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
          return;
        }
      }

      for (let k = 0; k < previousJobs.length; k++) {
        if (k > 0) {
          if (previousJobs[k].joining_date <= previousJobs[k - 1].resignation_termination_date) {
            this.$bvToast.toast("Dates must not overlap with the previous job's resignation date (" + previousJobs[k - 1].resignation_termination_date + ").", {
              title: "Sequential Date Conflict",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            });
            return;
          }
        }

        if (k === previousJobs.length - 1) {
          if (activeJoining && previousJobs[k].resignation_termination_date >= activeJoining) {
            this.$bvToast.toast("Resignation/Termination Date must be earlier than the contracted start date (" + activeJoining + ").", {
              title: "Sequential Date Conflict",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            });
            return;
          }
        } else {
          if (previousJobs[k].resignation_termination_date >= previousJobs[k + 1].joining_date) {
            this.$bvToast.toast("Dates must not overlap with the next job's joining date (" + previousJobs[k + 1].joining_date + ").", {
              title: "Sequential Date Conflict",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            });
            return;
          }
        }
      }

      this.saving = true;
      const payload = {
        ...this.form,
        signatory_id: this.selected_signatory_id
      };

      const url = this.isEdit
        ? this.$api_url + this.apiPrefix + "/employment-details/" + this.editId
        : this.$api_url + this.apiPrefix + "/employment-details";

      axios.post(url, payload)
        .then(() => {
          this.$bvToast.toast(this.isEdit ? "Updated successfully" : "Saved successfully", { title: "Success", variant: "success", solid: true, autoHideDelay: 3000 });
          this.showModal = false;
          this.fetchData();
        })
        .catch((err) => {
          const msg = err.response && err.response.data && err.response.data.error ? err.response.data.error : "Error saving data";
          this.$bvToast.toast(msg, { title: "Error", variant: "danger", solid: true, autoHideDelay: 5000 });
        })
        .finally(() => { this.saving = false; });
    },
    resetForm() {
      this.isEdit = false;
      this.editId = null;
      this.submitAttempted = false;
      this.isAutofetched = false;
      this.form = {
        factory_name_address: { en: "", bn: "" },
        owner_authority_name: { en: "", bn: "" },
        reason_of_termination: { en: "", bn: "" },
        joining_date: "",
        resignation_termination_date: "",
      };
      this.selected_signatory_id = null;
      this.ownerSigPreview = null;
      this.workerSigPreview = null;
      this.thumbImpPreview = null;
    },
    fetchSignatories() {
      axios.get(this.$api_url + this.apiPrefix + "/signatories").then((res) => { this.signatories = res.data; });
    },
    onSignatoryChange(id) {
      if (!id) {
        this.ownerSigPreview = null;
        return;
      }
      const s = this.signatories.find(x => x.id == id);
      if (s && s.signature) this.fetchAsBlob(s.signature).then(b => { this.ownerSigPreview = b; });
      else this.ownerSigPreview = null;
    },
  },
};
</script>
<style scoped>
.custom-table th { background-color: #f8f9fa; font-size: 0.85rem; padding: 12px 8px; vertical-align: middle; }
.custom-table td { font-size: 0.9rem; padding: 10px 8px; vertical-align: middle; }
.sig-thumb { max-height: 40px; max-width: 80px; }
.img-preview { max-height: 80px; max-width: 150px; border: 1px solid #ddd; padding: 4px; border-radius: 4px; background: #fff; }
.add-entry-btn { font-weight: 500; padding-left: 1.25rem; padding-right: 1.25rem; }
.bg-light-blue { background-color: rgb(234, 246, 255) !important; }
.bg-light-cyan { background-color: #e0f7fa; }
.bn-text { font-family: "SolaimanLipi", sans-serif; }
.sorting:after { content: "\f0dc"; font-family: "Font Awesome 5 Free"; font-weight: 900; float: right; color: #ccc; }
.sorting_asc:after { content: "\f0de"; font-family: "Font Awesome 5 Free"; font-weight: 900; float: right; color: #333; }
.sorting_desc:after { content: "\f0dd"; font-family: "Font Awesome 5 Free"; font-weight: 900; float: right; color: #333; }
</style>
